import React, { Component, Suspense, lazy } from 'react'
import { Route, Switch } from 'react-router-dom'
import Layout from '../Layout'
import Loading from '../Loading'
import { Provider } from '../../context'

const Frontpage = lazy(() => import('../../views/Frontpage'))
const LeaveForm = lazy(() => import('../../views/LeaveForm'))
const Error = lazy(() => import('../../views/Error'))
const Sent = lazy(() => import('../../views/Sent'))
const ErrorValidation = lazy(() => import('../../views/ErrorValidation'))
const Confirmation = lazy(() => import('../../views/Confirmation'))
const AlarmCompanyForm = lazy(() => import('../../views/AlarmCompanyForm'))
const AlarmConsumerForm = lazy(() => import('../../views/AlarmConsumerForm'))
const AlarmPrivateForm = lazy(() => import('../../views/AlarmPrivateForm'))
const EmployerForm = lazy(() => import('../../views/EmployerForm'))

const withSuspense = Component => {
  return props => (
    <Suspense fallback={<Loading />}>
      <Layout>
        <Component {...props} />
      </Layout>
    </Suspense>
  )
}

const Routes = () => {
  return (
      <Switch>
        <Provider>
          <Route
            exact
            path="/"
            render={withSuspense(Frontpage)}
          />
          <Route
            exact
            path="/ledighetsansokan"
            component={withSuspense(LeaveForm)}
          />
         <Route
            exact
            path="/annan-arbetsgivare"
            component={withSuspense(EmployerForm)}
          />
          <Route
            exact
            path="/inskickad"
            component={withSuspense(Confirmation)}
          />
          <Route
            exact
            path="/kundunderlag-foretag"
            component={withSuspense(AlarmCompanyForm)}
          />
         <Route
            exact
            path="/kundunderlag-personlarm"
            component={withSuspense(AlarmConsumerForm)}
          />
                   <Route
            exact
            path="/kundunderlag-privat"
            component={withSuspense(AlarmPrivateForm)}
          />
          <Route
            exact
            path="/error"
            component={withSuspense(Error)}
          />
                   <Route
            exact
            path="/sent"
            component={withSuspense(Sent)}
          />
          <Route
            exact
            path="/error-validation"
            component={withSuspense(ErrorValidation)}
          />
        </Provider>
      </Switch>
  )
}

export default Routes